
import { Component, Vue } from 'vue-property-decorator'
import { BillingTypes } from "@/types/project/billing_types"
import Project from "@/types/project/project"

@Component({
  components: {
  }
})
export default class CreateProject extends Vue {
  private valid = false
  private active = true
  private name: string | null = null
  private description: string | null = null
  private billingType = BillingTypes.HOURLY
  private salary: number | null = null

  private notEmptyRule = [
    (v: any) => !!v || this.$t('global.required')
  ]

  get paymentLabel () {
    return this.billingType === BillingTypes.HOURLY
      ? this.$t('timetrack.projects.projectdata.hourlypayment')
      : this.$t('timetrack.projects.projectdata.fixedpayment')
  }

  get billingTypes () {
    const types = []
    for (const type in BillingTypes) {
      types.push(
        {
          value: type.toLowerCase(),
          translation: this.$t('timetrack.projects.projectdata.' + type.toLowerCase())
        })
    }
    return types
  }

  get projectData () {
    return new Project({
      name: this.name,
      owner: true,
      active: this.active,
      description: this.description,
      billingType: this.billingType,
      salary: this.salary
    })
  }
}
